import ForceGuide from '../../../common/forceGuide'

const imageDetailForceGuide = new ForceGuide('imageDetail')

export const GUIDE_KEYS = {
  STEP_1: 1,
  STEP_2: 2
}

export const GUIDE_START_KEY = 'IMAGE_DETAIL_START_KEY'
export const IMAGE_DETAIL_FORCE_GUIDE_STEP_KEY = 'IMAGE_DETAIL_FORCE_GUIDE_STEP_KEY'
export default imageDetailForceGuide
